import React from "react";
import styled from "styled-components";
import Body from "../Body";

const Wrap = styled.div`
  max-width: ${({ width = "35rem" }) => width};
  width: 100%;
  margin: 0 auto;
`;

export default ({ children, wrapWidth }) => (
  <Wrap width={wrapWidth}>
    <Body>{children}</Body>
  </Wrap>
);



// WEBPACK FOOTER //
// ./src/components/generic/layout/NarrowBody/index.js